const HeroSlider = () => {
    return (
        <div classNameName="hero">
      <div className=" hero-img ">
        <img src="https://res.cloudinary.com/difqzsduz/image/upload/v1647713860/Lunar%20store/hero1_jtomlo.jpg" alt="" className="responsive-img hero-1"/>
        <img src="https://res.cloudinary.com/difqzsduz/image/upload/v1647713859/Lunar%20store/hero3_pltfxn.jpg" alt="" className="responsive-img hero-2"/>

      </div>
    </div>
    )
}
export default HeroSlider;